import Layout from 'src/components/Layout';
import Navbar from 'src/components/NavBar';
import SelectACompanyPlaceholder from 'src/components/SelectACompanyPlaceholder';
import SelectCompany from 'src/components/SelectCompany';
import useCompany from 'src/hooks/useCompany';
import Export from 'src/sections/accrual-report/Export';
import ViewAccrualContextProvider from 'src/sections/accrual-report/ViewAccrualContext';
import ViewAccrualTable from 'src/sections/accrual-report/ViewAccrualTable';

const ViewAccrualReport = () => {
  const { company } = useCompany();

  return (
    <ViewAccrualContextProvider>
      <Navbar title="Accrual Report" />
      <Layout>
        <div className="flex justify-between items-center flex-wrap min-h-[56px]">
          <SelectCompany className="items-center" />
          {!!company.companyId && (
            <div className="flex flex-wrap items-center gap-2">
              <Export />
            </div>
          )}
        </div>
        <SelectACompanyPlaceholder display={<ViewAccrualTable />} />
      </Layout>
    </ViewAccrualContextProvider>
  );
};

export default ViewAccrualReport;
